import { Pipe, PipeTransform } from '@angular/core';

import { IntlService } from '@frontend/vanilla/core';

import { EpcotConfigService } from '../../common/epcot-config.service';

@Pipe({ name: 'msMyBetsEventDatePipe' })
export class MyBetsEventDatePipe implements PipeTransform {
    isEpcotEnabled = false;

    constructor(
        private intlService: IntlService,
        private epcotConfigService: EpcotConfigService,
    ) {
        this.isEpcotEnabled = this.epcotConfigService.isEnabled();
    }

    transform(value: Date): string {
        return `${this.intlService.formatDate(value, 'shortDate')} ${this.isEpcotEnabled ? '•' : ''} ${this.intlService.formatDate(
            value,
            'shortTime',
        )}`;
    }
}
